// Builds the URL focus-challenge navigates to (via location.href) to open the
// Forest Plus paywall. trial-paywall reads the locale from the `language` query
// param; permanent-paywall reads it from a path segment. See ADR 0039.

export type PaywallTarget = 'trial' | 'permanent'

type DeployKey = 'production' | 'staging' | 'dev'

const HOSTS: Record<PaywallTarget, Record<DeployKey, string>> = {
  trial: {
    production: 'forest-trial-paywall.seekrtech.com',
    staging: 'forest-trial-paywall-staging.seekrtech.com',
    dev: 'forest-trial-paywall-dev.seekrtech.com',
  },
  permanent: {
    production: 'forest-permanent-paywall.seekrtech.com',
    staging: 'forest-permanent-paywall-staging.seekrtech.com',
    dev: 'forest-permanent-paywall-dev.seekrtech.com',
  },
}

// Params focus-challenge carries that the paywalls have no use for. Everything
// else is forwarded verbatim (incl. device_region and anything native adds).
const DROP_PARAMS = ['ts', 'mock', 'debug']

// Mirrors the env mapping in `~/lib/api` getServiceUrl: production and dev are
// explicit, anything else (incl. local `development`) resolves to staging.
function deployKey(mode: string): DeployKey {
  if (mode === 'production') return 'production'
  if (mode === 'dev') return 'dev'
  return 'staging'
}

export function buildPaywallUrl(opts: {
  target: PaywallTarget
  mode: string
  language: string
  search: string
}): string {
  const { target, mode, language, search } = opts
  const host = HOSTS[target][deployKey(mode)]

  const params = new URLSearchParams(search)
  for (const key of DROP_PARAMS) params.delete(key)
  params.set('enter_from', 'focus_challenge')

  const path = target === 'permanent' ? `/${language}/` : '/'
  return `https://${host}${path}?${params.toString()}`
}
